export default __webpack_public_path__ + "static/media/mn_tea_sub_7.21cda74c.png";